import { render, staticRenderFns } from "./TsPreviewPdf.vue?vue&type=template&id=54631760&scoped=true"
import script from "./TsPreviewPdf.vue?vue&type=script&lang=js"
export * from "./TsPreviewPdf.vue?vue&type=script&lang=js"
import style0 from "./TsPreviewPdf.vue?vue&type=style&index=0&id=54631760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54631760",
  null
  
)

export default component.exports